import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-menu-links',
  templateUrl: './menu-links.component.html',
  styleUrls: ['./menu-links.component.scss']
})
export class MenuLinksComponent implements OnInit {
  @Input() class: string;
  constructor() { }

  ngOnInit(): void {
  }

}
